import styled from "styled-components";
import {Button} from "antd";


export const Header = styled.div`
    position: relative;
  height: 36px;
`;
export const Body = styled.div`
    padding: 20px;
`;

export const Right = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  //cursor: pointer;
  transition: color 0.3s;
`;
export const CloseButton = styled.button`
  //position: absolute;
  //top: 0;
  //right: 0;
  z-index: 10;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
  .ant-modal-close-x {
    width: 36px;
    height: 36px;
  }
`;

export const Title = styled.h2`
    
`;

export const Content = styled.div`
  font-size: 14px;
  line-height: 24px;
  margin-top: 15px;
`;

export const Footer = styled.div`
    display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 30px 0 20px;
  
`;


export const Center = styled.div`
  display: flex;
  flex-direction: column;
`;
export const PrimaryButton = styled(Button)`
  &.ant-btn-primary {
    border-color: #ff7346;
    background-color: #ff7346;
  }
  &.ant-btn-primary:hover, &.ant-btn-primary:focus, &.ant-btn-primary:active {
    border-color: #FF603A;
    background-color: #FF603A;
  }
`;
export const SecondaryButton = styled(Button)`
    span {
      text-decoration: underline;
    }
`;

export const CancelButton = styled(Button)`
  &.ant-btn {
    position: absolute;
    right: 10px;
    color: #aaa;
    a:hover {
      color: #40a9ff;
    }
    a:active {
      color: #096dd9;
    }
  }
  
`;